import TimeAgo from "javascript-time-ago";

import { Tag } from "@design-system/Tag/Tag";
import { Text } from "@design-system/Text/Text";

import { formatExactDateTime } from "@utils/datetime";

import classes from "./DateCell.module.css";

type Props = {
  date: Date;
  /** When true, tooltip relative text uses day-level phrasing ("Today", "2 days ago"). */
  dayOnly?: boolean;
};

const timeAgo = new TimeAgo("en-US");

const formatDayLevel = (date: Date): string => {
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  if (diffMs < 0) return "In the future";

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays > 0) {
    return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
  }
  return "Today";
};

const formatRelative = (date: Date, dayOnly?: boolean): string => {
  if (dayOnly) {
    return formatDayLevel(date);
  }
  return timeAgo.format(date);
};

export const DateCell = ({ date, dayOnly }: Props) => {
  const exact = formatExactDateTime(date);

  if (!exact) {
    return <Text size={14}>—</Text>;
  }

  return (
    <div className={classes.root}>
      <Tag
        color="tertiary"
        noWrap
        text={exact}
        title={formatRelative(date, dayOnly)}
      />
    </div>
  );
};
